import React from "react";
import { TabbedShowLayout, Tab, ShowProps } from "react-admin";
import { Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import ShowWrapper from "../../components/ShowWrapper";

const DriverShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    {
      title: "Drivers",
      link: `/drivers`,
    },
    {
      title: id,
      link: "",
    },
  ];

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        customFieldName="fullName"
        {...props}
      >
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default DriverShow;
